<p-dialog
  modal="true"
  styleClass="atlas-dialog-l wl-transactions-grid-apply-payments-dialog"
  [closable]="false"
  [(visible)]="show"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ 'shared.container.toolbars.module.revenue.batch-payment-dialog.new-payment-batch' | translate | titlecase }}</h3>
  </ng-template>
  <div class="dialog-body-container">
    <div *ngIf="!invoiceNumbers">
      <p>{{ 'shared.container.toolbars.module.revenue.batch-payment-dialog.search-prompt' | translate }}</p>
      <div>
        <wl-profile-quicksearch
          [suppressAutoSearch]="true"
          (keywordChange)="keywordChanged($event)"
          (enterPressed)="enterPressed($event)"
          (searchComplete)="setResults($event)"
        ></wl-profile-quicksearch>
      </div>
      <div class="mct-flex mct-row mct-justify-center mct-items-center">
        <wl-busy class="busy-indicator" [show]="loadingProfileInvoices"></wl-busy>
      </div>
      <div *ngIf="profileResults">
        <wl-profile-results-grid [profiles]="profileResults" (onProfileSelected)="profileSelected($event)"></wl-profile-results-grid>
      </div>
    </div>
    <div [hidden]="!invoiceNumbers">
      <div class="mb-20 mct-flex mct-row" *ngIf="selectedProfile">
        <wl-profile-type-icon
          [isMember]="selectedProfile.Member"
          [isOrg]="selectedProfile.OrgInd"
          [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"
          [profileId]="selectedProfile.ProfileId"
        ></wl-profile-type-icon>
        <h4>
          {{ selectedProfile.ReportName }} <span class="profile-id">({{ selectedProfile.ProfileId }})</span>
        </h4>
      </div>
      <wl-multi-invoice-payment
        [invoiceNumbers]="invoiceNumbers"
        (profileIdentified)="loadInvoiceProfile($event)"
      ></wl-multi-invoice-payment>
    </div>
  </div>
  <ng-template class="mct-flex mct-row mct-justify-end mct-items-center" pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary tall" (click)="cancelClicked()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <div *ngIf="invoiceNumbers">
      <button pButton type="button" class="atlas-btn atlas-btn-primary tall" [disabled]="isSaving" (click)="save()">
        <span *ngIf="!isSaving">{{
          'shared.container.toolbars.module.revenue.batch-payment-dialog.save-and-close' | translate | uppercase
        }}</span>
        <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary tall ml-5" [disabled]="isSaving" (click)="save(true)">
        <span *ngIf="!isSaving">{{
          'shared.container.toolbars.module.revenue.batch-payment-dialog.save-and-add-payment' | translate | uppercase
        }}</span>
        <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
      </button>
    </div>
  </ng-template>
</p-dialog>
